<template>
<div class="chapter">
<div class="inner_page">
<a id="page_x"></a>
<h2 class="fm-title"><span class="bold">Main Characters</span></h2>
<p class="noindenth"><span class="bold">Trotsky’s Family</span></p>
<p class="noindentf">David Bronstein (1874–1922) – father</p>
<p class="noindentf">Anna Bronstein (1850–1910) – mother</p>
<p class="noindentf">Alexander Bronstein (1870–<span class="bold">1938</span>) – older brother</p>
<p class="noindentf">Yelizaveta Bronstein (1875–1924) – older sister</p>
<p class="noindentf">Olga Bronstein (1883–<span class="bold">1941</span>) – younger sister; an Oppositionist</p>
<p class="noindentf">Aleksandra Sokolovskaya (1872–<span class="bold">1938</span>) – Marxist revolutionary; Trotsky’s (first) wife; an Oppositionist</p>
<p class="noindentf">Zina Trotsky (1901–<span class="bold">33</span>) – elder daughter; an Oppositionist</p>
<p class="noindentf">Nina Trotsky (1902–28) – younger daughter; an Oppositionist</p>
<p class="noindentf">Natalya Sedova (1882–1962) – Trotsky’s (common-law) wife; an Oppositionist</p>
<p class="noindentf">Lyova Sedov (1906–<span class="bold">38</span>) – elder son; an Oppositionist</p>
<p class="noindentf">Sergei Sedov (1908–<span class="bold">37</span>) – younger son</p>
<p class="noindentf">Zakhar Moglin (1897–<span class="bold">1937</span>) – Zina’s first husband; an Oppositionist</p>
<p class="noindentf">Platon Volkov (1898–<span class="bold">1938</span>) – Zina’s second husband; an Oppositionist</p>
<p class="noindentf">Man Nevelson (1896–<span class="bold">1937</span>) – Nina’s husband; an Oppositionist</p>
<p class="noindentf">Anya Riabukhana (1899–<span class="bold">1938</span>) – Lyova’s wife</p>
<p class="noindentf">Seva (Esteban) Volkov (1926–) – grandson</p>
<p class="noindentf">Aleksandra Moglin (1923–89) – granddaughter (she met Seva – her half-brother – who travelled from Mexico to Russia just before she died; but they couldn’t communicate, as she had no Spanish or English, and he had forgotten Russian)</p>
<p class="noindentf">Lev Nevelson (1921–?) – grandson; fate unknown</p>
<p class="noindentf">Volina Nevelson (1926–?) – granddaughter; fate unknown</p>
<p class="noindentf">Lyulik Sedov (1926–?) – grandson; fate unknown</p>
<p class="noindentf">Yulia Sedov-Rubinstein (1936–) – granddaughter</p>
<p class="noindenth"><span class="bold">Trotsky’s Main Supporters</span></p>
<p class="noindentf">Vladimir Antonov-Ovseenko (1883–<span class="bold">1938</span>)</p>
<p class="noindentf">Jan Frankel (1906–84)</p>
<a id="page_xi"></a>
<p class="noindentf">Joseph Hansen (1910–79)</p>
<p class="noindentf">Jean van Heijenoort (1912–86)</p>
<p class="noindentf">Adolfe Joffe (1883–<span class="bold">1927</span>)</p>
<p class="noindentf">Rudolf Klement (1908–<span class="bold">38</span>)</p>
<p class="noindentf">Nikolai Krestinsky (1883–<span class="bold">1938</span>)</p>
<p class="noindentf">Anatoly Lunacharsky (1875–1933)</p>
<p class="noindentf">Raymond Molinier (1904–94)</p>
<p class="noindentf">Nikolai Muralov (1877–<span class="bold">1937</span>)</p>
<p class="noindentf">Alexander Parvus (1867–1924)</p>
<p class="noindentf">Yevgeni Preobrazhensky (1886–<span class="bold">1937</span>)</p>
<p class="noindentf">Georgei Pyatakov (1880–<span class="bold">1937</span>)</p>
<p class="noindentf">Karl Radek (1885–<span class="bold">1939</span>)</p>
<p class="noindentf">Christian Rakovsky (1873–<span class="bold">1941</span>)</p>
<p class="noindentf">Ignaz Reiss(1899–<span class="bold">1937</span>)</p>
<p class="noindentf">Alfred Rosmer (1877–1964)</p>
<p class="noindentf">David Ryazanov (1870–<span class="bold">1938</span>)</p>
<p class="noindentf">Max Schachtman (1904–72)</p>
<p class="noindentf">Ephraim Skylansky (1892–<span class="bold">1925</span>)</p>
<p class="noindentf">Ivan Smirnov (1881–<span class="bold">1936</span>)</p>
<p class="noindentf">Vladimir Smirnov (1887–<span class="bold">1937</span>)</p>
<p class="noindentf">Grigori Sokolnikov (1888–<span class="bold">1939</span>)</p>
<p class="noindentf">Moisei Uritsky (1873–1918) – Chekist; assassinated</p>
<p class="noindentf">Erwin Wolf (1902–<span class="bold">37</span>)</p>
<p class="noindenth"><span class="bold">Other Leading Russian Marxists</span></p>
<p class="noindentf">Paul Axelrod (1850–1928) – leading member of the RSDWP; later a Menshevik</p>
<p class="noindentf">Nikolai Bukharin (1888–<span class="bold">1938</span>) – leading member of the RSDWP; later a Bolshevik; later an Oppositionist</p>
<p class="noindentf">Felix Dzershinsky (1877–1926) – Bolshevik; head of the Cheka, the GPU &amp; then the OGPU</p>
<p class="noindentf">Lev Kamenev (1883–<span class="bold">1936</span>) – leading member of the RSDWP; later a Bolshevik; one of the anti-Trotsky triumvirate; later an Oppositionist (also Trotsky’s son-in-law)</p>
<p class="noindentf">Nadezhda Krupskaya (1869–1939) – leading Bolshevik; Lenin’s wife</p>
<p class="noindentf">Mikhail Lashevich (1884–<span class="bold">1928</span>) – initially a Bolshevik; later an Oppositionist</p>
<p class="noindentf">Vladimir I. Lenin (1870–1924) – early Russian Marxist; leading member of the RSDWP; later head of the Bolsheviks</p>
<a id="page_xii"></a>
<p class="noindentf">Julius Martov (1873–1923) – leading member of the RSDWP; later Menshevik, Internationalist Menshevik</p>
<p class="noindentf">Georgi Plekhanov (1856–1918) – early Russian Marxist; leader of the RSDWP</p>
<p class="noindentf">Alexander Potresov (1869–1934) – leading member of the RSDWP; later a Menshevik</p>
<p class="noindentf">Joseph Stalin (1878–1953) – Bolshevik, and one of the anti-Trotsky triumvirate</p>
<p class="noindentf">Vera Zasulich (1851–1919) – leading member of the RSDWP; later a Menshevik</p>
<p class="noindentf">Gregorii Zinoviev (1883–<span class="bold">1936</span>) – leading member of the RSDWP; later a Bolshevik; one of the anti-Trotsky triumvirate; later an Oppositionist</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08_Maincharacters.vue?fa19dd50